import React, {useEffect} from 'react';
import {Navigate} from "react-router-dom";
import {logout} from "../../redux/actions/authAction";
import {useDispatch} from "react-redux";

const Logout =()=>{
    const dispatch = useDispatch();

    useEffect(()=>{
        dispatch(logout());
    },[])


    return <Navigate to="/"/>

}

export default Logout;